export const appMicrosoftPlaces = "BnS9qe";
export const hybridspacePlacesTitle = "yF3e4";
export default {appMicrosoftPlaces,hybridspacePlacesTitle};